import { createApp } from 'vue';
import { getAppStore, fetchJourneys, fetchOptions, fetchOptionGroups } from '@/store';
import FuneralConfigurator from '@/FuneralConfigurator.vue';
import Print from 'vue-print-nb';
import VueScrollTo from 'vue-scrollto';
import "@popperjs/core"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

const journeysRequest = fetchJourneys();
const optionsRequest = fetchOptions();
const optionGroupsRequest = fetchOptionGroups();


Promise.all([journeysRequest, optionsRequest, optionGroupsRequest]).then(() => {
   const store = getAppStore();

   createApp(FuneralConfigurator)
   .use(store)
   .use(Print)
   .use(VueScrollTo)
   .mount('#funeral-configurator');
});




// Vue.config.productionTip = false;
